import ACTION_TYPES from "../actions/type.action";

const initialState = {
	notifications: [],
	notificationCount: 0
};

const reducer = (state = initialState, action) => {
	const {
		type,
		payload
	} = action;

	switch (type) {
		case ACTION_TYPES.GETALL_NOTIFICATION:
			return {
				...state,
				notifications: payload.notifications,
				notificationCount: payload.newMessagesCount
			};
		case ACTION_TYPES.DELETEALL_NOTIFICATION:
			return {
				...state,
				notifications: []
			};
        default:
			return state;
	}
};

export default reducer;